import { Product } from "@/types/types.ts";

export const isMadeToMeasure = (product: Product) => {
  const type = product?.configurationRequirements?.type;
  return (
    (type &&
      (type.includes("MadeToMeasureRomanBlind") ||
        type.includes("MadeToMeasureCurtain"))) ||
    false
  );
};

export const isM2MRomanBlindOrCurtain = (product: Product) => {
  const type = product?.configurationRequirements?.type;
  return (
    (type &&
      (type.includes("MadeToMeasureRomanBlind") ||
        type.includes("MadeToMeasureCurtain"))) ||
    false
  );
};
